import { Button, Card, Typography } from 'antd';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';

import { BearLossCalculatorModal } from './BearLossCalculatorModal';

import { useAppSelector, useTranslate } from 'hooks';

import { language } from 'utils';

import { selectIsAdmin, selectUser } from 'selectors';

import styles from './index.module.scss';

const isEn = ['en','ro'].includes(language);

export const BearLossCalculator = () => {
	const user = useAppSelector(selectUser);
	const isAdmin = useAppSelector(selectIsAdmin);
	const location = useLocation();
	const navigate = useNavigate();

	const { checkText, checkAbilityLossText, readMoreText } = useTranslate([
		'checkText',
		'checkAbilityLossText',
		'readMoreText',
	]);

	const isOpenCalculator = location.state?.isOpenCalculator;
	const [isOpen, setIsOpen] = useState(isOpenCalculator || false);

	useEffect(() => {
		setIsOpen(isOpenCalculator);
	}, [isOpenCalculator]);

	return (
		<Card bordered={false} className={styles.root}>
			<Typography.Title level={4}>{checkAbilityLossText}</Typography.Title>

			<div className={`${styles.row} bearLoss_actions`}>
				<a
					href={
						isEn
							? 'https://crowdpear.com/wp-content/uploads/2023/09/Procedure_for_assessing_the_suitability_of_crowdfunding_transactions_and_modelling_of_the_capacity_for_loss.pdf'
							: 'https://crowdpear.com/wp-content/uploads/2023/09/Sutelktinio_finansavimo_sandoriu_tinkamumo_vertinimo_bei_gebejimo_prisiimti_nuostolius_modeliavimo_tvarka.pdf'
					}
					className={styles.link}
					target="_blank"
					rel="noreferrer"
				>
					{readMoreText}
				</a>

				<Button
					className={classNames(styles.button, { 'ant-btn-grey': isAdmin })}
					type="primary"
					onClick={() => setIsOpen(true)}
				>
					{checkText}
				</Button>
			</div>

			{isOpen && (
				<BearLossCalculatorModal
					isOpen={isOpen}
					onClose={() => {
						setIsOpen(false);
						if (location.state?.isOpenCalculator) {
							navigate(location.pathname, { state: null });
						}
					}}
					value={user.riskTolerance?.value}
				/>
			)}
		</Card>
	);
};
